export const layerVisSelector = state => state.layerVis;
export const layerOpacitySelector = state => state.layerOpacity;
